import { Injectable } from "@angular/core";
import { GAService } from "@apps/patient-core/src/app/services/ga.service";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { LocationService } from "@apps/patient-core/src/app/services/location.service";
import { FeatureFlagsService } from "@apps/patient-core/src/app/services/feature-flags.service";
import { NavigationService } from "@apps/patient-core/src/app/services/navigation.service";
import { CachedHttpService } from "@apps/patient-core/src/app/services/cached-http.service";
import { LocalisationService } from "@apps/patient-core/src/app/services/localisation.service";
import { ConciergeDataService } from "../concierge-data.service";

import { BaseCommonService } from "@apps/patient-core/src/app/services/abstracts/common.service";
import { BaseBrandService } from "@apps/patient-core/src/app/services/abstracts/brand.service";
import { BasePatientsService } from "@apps/patient-core/src/app/services/abstracts/patients.service";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";
import { logger } from "@dentally/ui/logger";
import { IFeatureFlags } from "@backend/common/interfaces/feature-flags.interface";
import { BrandInfoBase } from "@backend/graph/brand_info/brand-info-base";
@Injectable({
  providedIn: "root",
})
export class ConciergeCommonService extends BaseCommonService {
  constructor(
    _brandService: BaseBrandService,
    _patientsService: BasePatientsService,
    _authService: BaseAuthService,
    _gaService: GAService,
    _cacheService: CacheService,
    _locationService: LocationService,
    _featureFlagsService: FeatureFlagsService,
    _navigationService: NavigationService,
    _cachedHttpService: CachedHttpService,
    _localisationService: LocalisationService,
    private _conciergeDataService: ConciergeDataService
  ) {
    super(
      _brandService,
      _patientsService,
      _authService,
      _gaService,
      _cacheService,
      _locationService,
      _featureFlagsService,
      _navigationService,
      _cachedHttpService,
      _localisationService
    );
  }

  protected _handleDomainInfo302(graphData: { redirect_uri: string }, _pathname: string): void {
    this._conciergeDataService.setConciergeDataSiteUrl(`https://${graphData.redirect_uri}`);
    window.location.reload();
  }

  protected _handleDomainInfo404(graphData: { code: number }): void {
    super._handleDomainInfo404(graphData);

    logger.error("Error getting brand info on pair domain, deleting Concierge data and navigating to pair");

    this._conciergeDataService.deleteConciergeData();
    this._navigationService.navigate("pair");
  }

  protected _handleDomainInfo200(
    graphData: BrandInfoBase & { code?: number; redirect_uri?: string; feature_flags: IFeatureFlags; iso_country_code: string },
    pathname: string
  ): void {
    super._handleDomainInfo200(graphData, pathname);
  }

  protected get allowAutocomplete(): boolean {
    return false;
  }
}
